// features/signatures/components/VerificationActions.tsx
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { FeedbackDialog } from '@/components/form/feedback-dialog'

type Props = {
  onVerify: () => Promise<void> | void
  onDeny: () => Promise<void> | void
}

export function VerificationActions({ onVerify, onDeny }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null)
  const [busy, setBusy] = useState<'verify' | 'deny' | null>(null)

  const run = async (kind: 'verify' | 'deny', fn: () => Promise<void> | void, success: string) => {
    try {
      setBusy(kind)
      await fn()
      setMessage({ type: 'success', text: success })
    } catch (err: any) {
      const text = err?.response?.data?.message || 'Erro ao atualizar status!'
      setMessage({ type: 'error', text })
    } finally {
      setBusy(null)
      setIsOpen(true)
    }
  }

  return (
    <>
      <div className="flex justify-end gap-4 mt-6">
        <Button variant="destructive" disabled={busy !== null} onClick={() => run('deny', onDeny, 'Status: Negado')}>
          {busy === 'deny' ? 'Negando...' : 'Negar'}
        </Button>
        <Button
          variant="default"
          className="bg-green-600 hover:bg-green-700"
          disabled={busy !== null}
          onClick={() => run('verify', onVerify, 'Status: Verificado')}
        >
          {busy === 'verify' ? 'Verificando...' : 'Verificar'}
        </Button>
      </div>

      <FeedbackDialog isOpen={isOpen} onOpenChange={setIsOpen} message={message} />
    </>
  )
}
